var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.483 25.165 9.66-9.668a3.418 3.418 0 0 1 4.83 0 3.425 3.425 0 0 1 0 4.835L20.313 30a3.418 3.418 0 0 1-4.83 0 3.424 3.424 0 0 1 0-4.835zM2 16.503a3.418 3.418 0 0 0 4.828 0l9.66-9.67a3.425 3.425 0 0 0 0-4.833 3.418 3.418 0 0 0-4.83 0l-9.66 9.668a3.425 3.425 0 0 0 0 4.835zm10.361 3.121a3.417 3.417 0 0 0 4.832 0l2.415-2.417a3.425 3.425 0 0 0 0-4.835 3.418 3.418 0 0 0-4.83 0l-2.416 2.417a3.424 3.424 0 0 0 .001 4.834z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMft);
export default __webpack_public_path__ + "static/media/MFT.e0c009f808f70db041c209da1048a6c2.svg";
export { ForwardRef as ReactComponent };